<template>
  <v-container >
    <v-layout column>
      <v-flex mb-2>
        <v-layout row>
          <v-flex class="filtersBar">
            <filters-bar
              title="Cerrados"
              title-class="headline" 
              title-box-size="md3"
              date-box-size="md3"
              :has-date-type="true"
              :filtersButton="false"
              @search="getData(false)"
              :filters="filters">
              <template slot="content">
                <v-flex md2>
                  <v-btn
                    block
                    class="h-100 ma-0 w-100"
                    @click="generateReport">
                      <v-icon small>fas fa-download</v-icon>
                  </v-btn>
                </v-flex>
              </template>
            </filters-bar>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs12>
                <transition name="fade-effect" mode="out-in">
                  <template v-if="isSearching || !loadedCharts">
                    <skeleton-box flat>
                      <skeleton-line class="skeleton-line-custom"></skeleton-line>
                    </skeleton-box>
                  </template>
                  <template v-else>
                    <solved-graphic v-if="data.length > 0" :data="data"></solved-graphic>
                    <template v-else>
                      <v-layout row class="sizebox align-center">
                        <v-flex class="text-xs-center">
                          <span class="headline">
                            No hay información
                          </span>
                        </v-flex>
                      </v-layout>
                    </template>
                  </template>
                </transition>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import FiltersBar from '@/components/global/FiltersBar';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import SolvedGraphic from './SolvedGraphic';

export default {
  props: {
    loadedCharts: {
      type: Boolean,
      default: false,
    },
    channel: {
      type: Object,
      required: true,
    },
  },
  components: {
    FiltersBar,
    SkeletonBox,
    SkeletonLine,
    SolvedGraphic,
  },
  mounted() {
    this.getData(true);
  },
  data() {
    return {
      data: [],
      isSearching: true,
      cancelToken: this.axios.CancelToken.source(),
      actual: moment().format('YYYY-MM'),
      filters: {
        date: moment().format('YYYY-MM'),
        dateType: 'month',
      },
    };
  },
  methods: {
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this.filters,
            status: 7,
            filename: 'Chats resueltos',
          },
          functionName: 'chat_center',
        },
      });
    },
    startListening() {
      this.channel.listen('.ChatCenterClosed', (event) => {
        if (this.filters.date === this.actual) {
          this.addData(event.category);
        }
      });
    },
    addData({ name }) {
      const findIt = this.data.find(x => x.name === name);
      if (findIt) {
        findIt.value += 1;
      } else {
        this.$set(this.data, this.data.length, {
          name,
          value: 1,
        });
      }
    },
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    getData(check = false) {
      this.isSearching = true;
      this.data = [];
      this.cancelRequest();
      this.axios.get('chat/center/solved/chats', {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.filters,
        },
      }).then((res) => {
        /* eslint no-param-reassign: ["error", { "props": false }] */
        const data = res.data;
        let total = 0;
        _.each(data, (category) => { total += category.value; });
        _.each(data, (category) => {
          const percent = (category.value * 100) / total;
          const checkLabel = (98 * percent) / 100;
          let html = '<div style="text-align: center;">';
          if ((checkLabel + 6) >= category.name.length) {
            html += `<span style="font-size: 15px; font-weight: 500px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {name}
            </span>
            <br />
            <span style="font-size: 22px; font-weight: bolder;">
              {value}
            </span>`;
          } else {
            html += `<span style="font-size:  ${percent}; font-weight: bolder;">
              {value}
            </span>`;
          }
          html += '</div>';
          category.label = html;
        });
        this.data = data;
        if (check) {
          this.startListening();
        }
      }).catch(() => {}).finally(() => {
        this.isSearching = false;
      });
    },
  },
};
</script>
<style scoped>
.sizebox {
  height: 65vh;
}
.skeleton-line-custom {
  border-radius: 0 !important;
  height: 65vh;
}
</style>




// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Solved/Index.vue